function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_972",
  "data-name": "Grupo 972",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_971",
  "data-name": "Grupo 971"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_933",
  "data-name": "Trazado 933",
  d: "M68.1,2.889h.482a.241.241,0,0,0,.179-.4L66.589.079a.241.241,0,0,0-.358,0L64.064,2.487A.241.241,0,0,0,64,2.649a.238.238,0,0,0,.021.1.241.241,0,0,0,.22.143h.482a.241.241,0,0,0,.181-.082l1.023-1.169V7.464a.241.241,0,0,0,.241.241h.482a.241.241,0,0,0,.241-.241V1.639l1.023,1.169A.242.242,0,0,0,68.1,2.889Z",
  transform: "translate(-64.002)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_934",
  "data-name": "Trazado 934",
  d: "M239.464,175.625a.241.241,0,0,0-.22-.143h-.482a.241.241,0,0,0-.181.082l-1.023,1.169v-5.826a.241.241,0,0,0-.241-.241h-.482a.241.241,0,0,0-.241.241v5.826l-1.023-1.169a.242.242,0,0,0-.181-.082h-.482a.241.241,0,0,0-.22.143.238.238,0,0,0-.021.1.241.241,0,0,0,.062.161l2.167,2.408a.241.241,0,0,0,.358,0l2.167-2.408A.241.241,0,0,0,239.464,175.625Z",
  transform: "translate(-230.816 -166.813)"
})));

function SvgFlechas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flechas",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.668,
    height: 11.558,
    viewBox: "0 0 8.668 11.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechas);
export default __webpack_public_path__ + "static/media/flechas.183cdf89.svg";
export { ForwardRef as ReactComponent };